var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    attrs: {
      value: _vm.value,
      items: _vm.items,
      "item-text": "text",
      "item-value": "id",
      outlined: "",
      dense: "",
      "hide-details": "",
      disabled: _vm.disabled,
      loading: _vm.loading,
    },
    on: { change: _vm.handleChange },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "span",
              {
                staticClass: "stato-mercato-label",
                style: _vm.statoMercatoStyle(item),
              },
              [
                _c("span", { staticClass: "stato-mercato-dot" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.text))]),
              ]
            ),
          ]
        },
      },
      {
        key: "item",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "v-list-item-content",
              { staticClass: "py-1" },
              [
                _c(
                  "v-list-item-title",
                  {
                    staticClass: "stato-mercato-label",
                    style: _vm.statoMercatoStyle(item),
                  },
                  [
                    _c("span", { staticClass: "stato-mercato-dot" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.text))]),
                  ]
                ),
                _vm._v(" "),
                item.description
                  ? _c("v-list-item-subtitle", {
                      staticClass: "stato-mercato-option-description",
                      domProps: { innerHTML: _vm._s(item.description) },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }